import { render, staticRenderFns } from "./TrendSingle.vue?vue&type=template&id=5d20bed2&"
import script from "./TrendSingle.vue?vue&type=script&lang=js&"
export * from "./TrendSingle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports